import { useTranslations } from '@vocab/react';
import { Box, Pagination, Stack, Text } from 'braid-design-system';
import type { FC } from 'react';

import {
  MAX_ITEMS,
  RETENTION_TIME_APPLIED,
  RETENTION_TIME_SAVED,
  JOB_TYPE,
} from 'src/const/app';
import { withScroll } from 'src/utils';

import translations from './JobsContainer.vocab';

type type = typeof JOB_TYPE.applied | typeof JOB_TYPE.saved;

interface Props {
  onClick: (page: number) => void;
  currentPage: number;
  totalPages: number;
  type: type;
}

const RETENTION_TIME_MAP: Record<type, string> = {
  [JOB_TYPE.applied]: RETENTION_TIME_APPLIED.toString(),
  [JOB_TYPE.saved]: RETENTION_TIME_SAVED.toString(),
};

const JobsContainerPaginationView: FC<Props> = ({
  onClick,
  currentPage,
  totalPages,
  type,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Box paddingY="large">
      <Stack space="large">
        <Pagination
          page={currentPage}
          total={totalPages}
          linkProps={({ page }) => ({
            href: `#`,
            onClick: withScroll((e) => {
              e.preventDefault();
              onClick(page);
            }),
          })}
          label="Pagination"
        />
        <Text tone="secondary" align="center">
          {type === JOB_TYPE.applied
            ? t('Results limit message for applied job', {
                days: RETENTION_TIME_MAP[type],
                qty: MAX_ITEMS.toString(),
              })
            : t('Results limit message for saved job', {
                days: RETENTION_TIME_MAP[type],
                qty: MAX_ITEMS.toString(),
              })}
        </Text>
      </Stack>
    </Box>
  );
};

export default JobsContainerPaginationView;
